var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.5C3 7.84314 4.34314 6.5 6 6.5H14C15.6569 6.5 17 7.84313 17 9.5C17 11.1569 15.6569 12.5 14 12.5H9C8.44772 12.5 8 12.9477 8 13.5C8 14.0523 8.44772 14.5 9 14.5H14C16.7614 14.5 19 12.2614 19 9.5C19 6.73857 16.7614 4.5 14 4.5H6C3.23858 4.5 1 6.73856 1 9.5C1 10.7674 1.47284 11.9268 2.25028 12.8076C2.61575 13.2216 3.24769 13.261 3.66175 12.8955C4.07581 12.53 4.1152 11.8981 3.74972 11.484C3.28243 10.9546 3 10.2615 3 9.5Z",
    fill: "#6A8991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5C7.23857 8.5 5 10.7386 5 13.5C5 16.2614 7.23857 18.5 10 18.5H18C20.7614 18.5 23 16.2614 23 13.5C23 12.2326 22.5271 11.0732 21.7497 10.1925C21.3843 9.77839 20.7523 9.739 20.3383 10.1045C19.9242 10.4699 19.8848 11.1019 20.2503 11.5159C20.7176 12.0454 21 12.7385 21 13.5C21 15.1569 19.6569 16.5 18 16.5H10C8.34313 16.5 7 15.1569 7 13.5C7 11.8431 8.34313 10.5 10 10.5H15C15.5523 10.5 16 10.0523 16 9.5C16 8.94772 15.5523 8.5 15 8.5H10Z",
    fill: "#6A8991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.b875663c5c2ad64386b09e76852fb7cb.svg";
export { ForwardRef as ReactComponent };